/* Tile Talk theme: category filters + episode detail views (?ep=N). */
(function () {
  function initFilters(root) {
    root.querySelectorAll("[data-filter-group]").forEach(function (group) {
      var chips = group.querySelectorAll(".chip");
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          chips.forEach(function (c) { c.setAttribute("aria-pressed", String(c === chip)); });
          var v = chip.dataset.filter;
          group.querySelectorAll("[data-cat]").forEach(function (el) {
            el.hidden = v !== "all" && el.dataset.cat !== v;
          });
        });
      });
    });
  }

  function initEpisodes(root) {
    root.querySelectorAll("[data-episodes]").forEach(function (wrap) {
      var n = new URLSearchParams(location.search).get("ep");
      var index = wrap.querySelector(".ep-index");
      wrap.querySelectorAll(".ep-detail").forEach(function (d) { d.hidden = true; });
      if (index) index.hidden = false;
      if (!n) return;
      var detail = wrap.querySelector('.ep-detail[data-ep="' + CSS.escape(n) + '"]');
      if (!detail) return;
      if (index) index.hidden = true;
      detail.hidden = false;
      detail.querySelectorAll("iframe[data-src]").forEach(function (f) { f.src = f.dataset.src; });
      var h = detail.querySelector("h1");
      if (h) document.title = "EP " + n + ": " + h.textContent.trim() + " | Tile Talk";
    });
  }

  function initWatch(root) {
    root.querySelectorAll(".watch-thumb[data-yt]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!btn.dataset.yt) return;
        var f = document.createElement("iframe");
        f.src = "https://www.youtube-nocookie.com/embed/" + btn.dataset.yt + "?autoplay=1";
        f.title = btn.getAttribute("aria-label").replace(/^Play /, "");
        f.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        f.allowFullscreen = true;
        var box = document.createElement("div");
        box.className = "watch-thumb playing";
        box.appendChild(f);
        btn.replaceWith(box);
      });
    });
  }

  function initTopic(root) {
    root.querySelectorAll("[data-topic]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var sel = document.getElementById("c-topic");
        if (!sel) return;
        e.preventDefault();
        for (var i = 0; i < sel.options.length; i++) if (sel.options[i].text.trim() === a.dataset.topic) sel.selectedIndex = i;
        sel.closest("form").scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  // Links to other websites (partners, tablescapes, guests) open in a new tab
  function initExternal(root) {
    root.querySelectorAll('a[href^="http"]').forEach(function (a) {
      if (a.hostname && a.hostname !== location.hostname) { a.target = "_blank"; a.rel = "noopener"; }
    });
  }

  function init(root) { initFilters(root); initEpisodes(root); initWatch(root); initTopic(root); initExternal(root); }
  document.addEventListener("DOMContentLoaded", function () { init(document); });
  // Re-run when sections are edited in the Shopify theme editor
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
